import { render } from "./ziBrain.vue?vue&type=template&id=516dd2b2"
import script from "./ziBrain.vue?vue&type=script&lang=js"
export * from "./ziBrain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__